/**
 * Class CountrySelector
 */
define([
    'jquery',
    'handlebars',
    'jquery/ui',
    'dropdownDialog'
], (
    $,
    Handlebars
) => {
    class CountrySelector {

        /**
         * Constructor
         *
         * @param {Object}  config  Configuration options passed in through JSON
         * @param {Element} element The element that this class was bound to
         *
         * @returns {null}
         */
        constructor(config, element) {
            const defaultConfig = {};
            // Merge default config options and provided config
            /** @type {Object} */
            this.config = { ...defaultConfig, ...config };
            this.countries = config.countries;
            this.websites = config.websites;
            /** @type {jQuery} */
            this.$element = $(element);
            this.$template = Handlebars.compile($('#country-selector-template').html());
            this.currentCountryCode = this.$element.closest('[data-block="country-selector"]').find('[data-js="current-country"]').data('countryCode');
            this.$countrySelector = this.$element.parent('.countrySelector');

            this.renderCountryList();
            this.attachListeners();
        }

        /**
         * Draw country list
         *
         * @returns {null}
         */
        renderCountryList() {
            this.$element.html(this.$template(this.countries));
        }

        /**
         * Attach event listeners to elements
         *
         * @returns {null}
         */
        attachListeners() {
            /**
             * redirect to relevant country site when changed
             */
            this.$element.on('click', '.country', (e) => {
                const thisCountryCode = $(e.currentTarget).data('countryCode');
                if (thisCountryCode !== this.currentCountryCode) {
                    const url = this.websites.hasOwnProperty(thisCountryCode) ? this.websites[thisCountryCode] : this.websites.intl;
                    window.location.href = `${url}?redirected=${thisCountryCode}`;
                } else {
                    this.$countrySelector.dropdownDialog('close');
                }
            });
        }
    }

    return (config, element) => {
        const countrySelector = new CountrySelector(config, element);
        return countrySelector;
    };
});
